// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomResultWrapper {
  height: 75vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.CustomResultWrapper .ant-result {
  padding: 0;
}
.CustomResultWrapper .ant-result .ant-result-title {
  color: #3a3a3c;
  font-family: "Poppins", sans-serif;
  font-size: 34px !important;
  font-weight: 700 !important;
  line-height: 1 !important;
  letter-spacing: 0em;
  margin: 0;
  padding: 10px 0;
}
.CustomResultWrapper .ant-result .ant-result-subtitle {
  color: #545454 !important;
  font-size: 18px;
}
.CustomResultWrapper .ant-result .ant-result-content {
  padding: 0;
  margin: 0;
  background: unset;
}
.CustomResultWrapper .ant-result .ant-result-content p {
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  letter-spacing: 0em;
  text-align: center;
  padding: 0;
  margin-top: 15px;
}
@media (min-width: 481px) and (max-width: 767px) {
  .CustomResultWrapper {
    height: 75vh;
  }
}
@media (min-width: 280px) and (max-width: 480px) {
  .CustomResultWrapper .ant-result .ant-result-title {
    font-size: 28px !important;
  }
  .CustomResultWrapper .ant-result .ant-result-subtitle {
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/UiComponents/CustomResult/CustomResult.less"],"names":[],"mappings":"AAEA;EAEE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFF;AAHA;EAOI,UAAA;AADJ;AANA;EASM,cAAA;EACA,kCAAA;EACA,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAAN;AAhBA;EAmBM,yBAAA;EACA,eAAA;AAAN;AApBA;EAuBM,UAAA;EACA,SAAA;EACA,iBAAA;AAAN;AAzBA;EA2BQ,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AACR;AAmCA;EACE;IACE,YAAA;EAjCF;AACF;AAsCA;EACE;IAGM,0BAAA;EAtCN;EAmCA;IAMM,eAAA;EAtCN;AACF","sourcesContent":["@import url(\"../../../assets/Styles/variables.less\");\n\n.CustomResultWrapper {\n  // height: 100%;\n  height: 75vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  .ant-result {\n    padding: 0;\n    .ant-result-title {\n      color: @primary-color-dark;\n      font-family: @primary-font-family;\n      font-size: 34px !important;\n      font-weight: 700 !important;\n      line-height: 1 !important;\n      letter-spacing: 0em;\n      margin: 0;\n      padding: 10px 0;\n    }\n    .ant-result-subtitle {\n      color: @text-color !important;\n      font-size: 18px;\n    }\n    .ant-result-content {\n      padding: 0;\n      margin: 0;\n      background: unset;\n      p {\n        font-family: @primary-font-family;\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 1;\n        letter-spacing: 0em;\n        text-align: center;\n        padding: 0;\n        margin-top: 15px;\n      }\n    }\n  }\n}\n\n// MEDIA QUERY START\n\n// ##Device = HD Desktops\n// ##Screen = 1600px to higher resolution desktops\n\n@media screen and (min-width: 1600px) {\n} //  Dont delete this bracket!\n\n// ##Device = Desktops\n// ##Screen = 1281px to higher resolution desktops\n@media (min-width: 1281px) and (max-width: 1599px) {\n} //  Dont delete this bracket!\n\n// ##Device = Laptops, Desktops\n// ##Screen = B/w 1025px to 1280px\n@media (min-width: 1025px) and (max-width: 1280px) {\n} //  1025px to 1280px (Laptops, Desktops) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (landscape)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\n} //  768px to 1024px (landscape) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (portrait)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) {\n} //  768px to 1024px (portrait) Dont delete this bracket!\n\n// ##Device = Low Resolution Tablets, Mobiles (Landscape)\n// ##Screen = B/w 481px to 767px\n@media (min-width: 481px) and (max-width: 767px) {\n  .CustomResultWrapper {\n    height: 75vh;\n  }\n} //  481px to 767px (Landscape) Dont delete this bracket!\n\n// ##Device = Most of the Smartphones Mobiles (Portrait)\n// ##Screen = B/w 280px to 480px\n@media (min-width: 280px) and (max-width: 480px) {\n  .CustomResultWrapper {\n    .ant-result {\n      .ant-result-title {\n        font-size: 28px !important;\n      }\n      .ant-result-subtitle {\n        font-size: 16px;\n      }\n    }\n  }\n} //  280px to 480px (Portrait) Dont delete this bracket!\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
